// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"86815ea3","5791":"35c8a871","6050":"d2d7e68d","9418":"ca562865"}[chunkId] + ".chunk.css";
};